export const RRS_REFINANCING_LOANS = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Refinansieringslån – så mye kan du spare',
  url: 'https://scoopr.no/refinansieringslan',
  description:
    'Med et refinansieringslån, eller bare refinansiering som det også kalles, samler du dyre smålån og kredittkort til ett billigere lån',
  datePublished: '2022-01-26T08:00:00+00:00',
  dateModified: '2022-02-03T08:00:00+00:00',
};
